const en = {
  share_title: 'Vodafone Share',
  share_internet_subtitle: 'Share Internet',
  share_coins_subtitle: 'Share Vcoin',
  share_balance_subtitle: 'Share balance',
  share_minutes_subtitle: 'Share minutes',
  share_label_choose_transfer: 'Choose the bundle',
  share_limit: '%1$s/%2$s %3$s',
  share_transfer_button: 'Transfer',
  share_phone_number: 'Phone number',
  share_label_problem: 'Oops, there\'s a problem!',
  share_label_success: 'Transferta u krye me sukses',
  share_button_go_back: 'Go back',
  share_button_close: 'Close',
  share_button_confirm: 'Confirm',
  share_pay_with: 'Pay with:',
  share_wrong_phone_format: 'Wrong format. The format should be: 3556xxxxxxxx',
  share_confirm_message: 'You are transfering %1$s to %2$s',
  share_payment_type_bill: 'Bill',
  share_payment_type_balance: 'Balance',
  share_minutes_label: 'The minutes you are transfering are valid until %1$s',
  share_balance_label: 'The balance you are transfering is valid until %1$s',
  share_internet_label: 'The internet you are transfering is valid until %1$s',
  share_vcoins_label: 'The Vcoins you are transfering are valid until %1$s',
  share_reached_daily_limit: 'You have reached your daily limit',
  share_reached_monthly_limit: 'You have reached your monthly limit',
  monthly_limit: 'Monthly limit',
  daily_limit: 'Daily limit',
  receiving_monthly_limit: 'Receiving limit',
  transfering_monthly_limit: 'Transfer limit',
  number_of_transfer: 'Number of transfers',
  share_reached_number_of_transfer: 'You have reached your number of transfers',
  share_reached_transfering_monthly_limit: 'You have reached your transfer limit',
  share_reached_receiving_monthly_limit: 'You have reached your receiving limit',
  share_no_transfer_options: 'You do not have any transfer option at the moment',
}

export default en
